/* eslint-disable */
import React, { useEffect, useRef, useState } from "react";
import { Form, Field, FormElement } from "@progress/kendo-react-form";
import { Checkbox } from "@progress/kendo-react-inputs";
import CollectionSelection from "../forms/CollectionSelection";
import * as API from '../API/api'
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { FixedSidebarWithIcons } from "../../components/FixedSidebarWithIcons";
import { CardList } from "../../components/CardList";
import { ENTITYNAME, LOCALSTORAGE_KEY, LOGEVENT, MENUTYPE, MODULE, SOCKET_ACTION, SOCKET_EVENTS } from "../constant/constant";
import { EditPageHeader } from "../../components/EditPageHeader";
import { toast } from 'react-toastify';
import { useTranslation } from "../../locale/useTranslation";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import PageCollectionSelection from "../forms/PageCollectionSelection";
import socket from "../socket/socket";
import { utility } from "../utility/utilityProvider";
import MultiLangInput from "../forms/helpercomponents/inputs/MultiLangInput";

export const OttMenuForm = (props) => {

    const loc = useLocation();

    const navigate = useNavigate();
    const { SID } = useParams();
    const lang = useTranslation();
    const Company = utility.getValue(LOCALSTORAGE_KEY.COMPANY);

    const [dataItem, setDataItem] = useState({
        SID: SID,
        Name: [],
        Platform: {},
        MenuType: {},
        Archive: false
    });

    const [OttPages, setOttPages] = useState([]);
    const [addPages, setAddPages] = useState(false);
    const [deleteOttAssetsSID, setDeleteOttPageSID] = useState([]);
    const [showOttPageEditForm, setShowOttPageEditForm] = useState(false);
    const [platform, setPlatform] = useState([]);
    const [openPages, setOpenPages] = useState(true);
    const [menuTypes, setMenuTypes] = useState([{}]);
    const addOttPagesRef = useRef();
    const setAddOttPagesRef = (data) => {
        addOttPagesRef.current = data;
    }

    //LANGUAGE CHANGES
    const [languages, _setLanguages] = useState([]);

    const selectedLanguageRef = useRef();
    const [selectedLanguage, _setSelectedLanguage] = useState({});
    const setSelectedLanguage = async (data, load = false) => {
        selectedLanguageRef.current = data;
        _setSelectedLanguage(data);
        if (SID > 0 && load) {
            await loadEditData();
        }
    }
    const languageRef = useRef();
    const setLanguages = (data) => {
        languageRef.current = data;
        _setLanguages(data);
    }

    useEffect(() => {
        pageRender();
    }, [])

    const pageRender = async () => {
        await loadcombo();
        if (SID > 0) {
            await loadEditData();
        }
    }

    const loadcombo = async () => {
        var platformRes = await API.getDataLookup(ENTITYNAME.Platform, { sort: { Description: 1 } });
        setPlatform(platformRes.data);
        var menuTypeRes = Object.keys(MENUTYPE).map((item) => {
            return { "Description": item, "_id": MENUTYPE[item] }
        });
        setMenuTypes(menuTypeRes);

        let languageRes = await API.getDataLookup(ENTITYNAME.Language, { sort: { Description: 1 }, query: ['Archive', '=', false] });
        setLanguages(languageRes.data);
        setSelectedLanguage(Company.Language);
    }

    const loadEditData = async () => {

        let linkData = {
            link_collection: 'ott_pages',
            link_field: 'Pages'
        }

        var res = await API.getEntity(props.entityname, parseInt(SID), linkData);

        if (res.success) {

            let data = {
                ...res.data,
                Name: Array.isArray(res.data.Name) ? res.data.Name : [{ langISO: Company.Language.ISOCode, value: res.data.Name }],
                MenuType: {
                    "_id": res.data.MenuType,
                    "Description": Object.keys(MENUTYPE).find(key => MENUTYPE[key] === res.data.MenuType)
                }
            }
            setDataItem(data);

            //LOAD PAGES DATA AS PER SELECTED LANGUAGE
            let pages = utility.getDataWithDisplayValueByLang(res.data.Pages, ['Name', 'DisplayName'], selectedLanguageRef.current);
            setOttPages(() => [...pages]);

        } else {
            toast.error(res.message, {
                position: toast.POSITION.TOP_RIGHT
            });
        }
    }

    const onChange = (e) => {
        console.log(e.target.value);
        setDataItem({ ...dataItem, [e.target.name]: e.target.value });
    };

    const isValid = () => {

        if (dataItem.Name == undefined || dataItem.Name.length == 0) {
            toast.error(`${lang.please_enter_name_error_message}`, {
                position: toast.POSITION.TOP_RIGHT
            });
            return false;
        }
        if (dataItem.Platform == undefined || Object.keys(dataItem.Platform).length == 0) {
            toast.error(`${lang.please_select_platform_error_message}`, {
                position: toast.POSITION.TOP_RIGHT
            });
            return false;
        }
        if (dataItem.MenuType == undefined || Object.keys(dataItem.MenuType).length == 0) {
            toast.error(`${lang.please_select_menu_type_error_message}`, {
                position: toast.POSITION.TOP_RIGHT
            });
            return false;
        }
        if (OttPages.length == 0) {
            toast.error(
                <div>
                    <strong>INVALID</strong>
                    <div style={{ fontSize: '13px' }}>{lang.atleast_attach_one_ott_pages_rails_error_message}</div>
                </div>,
                { position: toast.POSITION.TOP_RIGHT }
            );
            return false;
        }
        return true;
    }

    const handleSubmit = async (e) => {

        if (!isValid()) return;
        let saveData = {
            _id: dataItem._id,
            SID: dataItem.SID ?? 0,
            Name: dataItem.Name,
            Platform: {
                _id: dataItem.Platform._id,
                SID: dataItem.Platform.SID,
                Description: dataItem.Platform.Description
            },
            MenuType: dataItem.MenuType._id,
            Pages: OttPages.length > 0 ? OttPages.map(x => x._id) : [],
            Archive: dataItem.Archive ?? false,
        }
        console.log(saveData);
        let res = await API.saveData(ENTITYNAME.OttMenu, saveData);
        if (res.success) {
            let logData = { event: saveData.SID == 0 ? LOGEVENT.CREATE_OTT_MENU : LOGEVENT.UPDATE_OTT_MENU, module: MODULE.OTTMENU, data: res.data, message: res.message };
            API.SaveLogs(logData);
            utility.deleteLocalStorageItem(ENTITYNAME.OttMenu);
            //delay for 1 sec
            setTimeout(() => {

                socket.emit(SOCKET_EVENTS.onSocketData, {
                    action: SOCKET_ACTION.PLATFORM_MENU_REFRESH,
                    module: MODULE.PLATFORM,
                    data: "Menu updated",
                    // user: { name: userData.name, _id: userData._id }
                });

            }, 2000)

            toast.success(lang.update_successfully_label, {
                position: toast.POSITION.TOP_RIGHT
            });

        } else {
            toast.error(res.message, {
                position: toast.POSITION.TOP_RIGHT
            });
        }
    }

    const deleteOttPage = (index, dataItem) => {
        setOttPages(old => old.filter((item, i) => {
            return index !== i;
        }))
        if (dataItem.SID !== 0) {
            setDeleteOttPageSID(old => [...old, dataItem.SID])
        }
        toast.success(`${lang.delete_successfully_grid_data_success_toast_message}`, {
            position: toast.POSITION.TOP_RIGHT
        });
    }

    const editPages = (index, dataItem) => {
        window.open(`/home/Page/${dataItem.SID}`, '_blank')
    }

    const draggedAssetItem = useRef();
    const draggedOverAsset = useRef();
    const selectedDraggedItem = useRef();

    const onDragStart = (e, position, selectedDataItem) => {
        draggedAssetItem.current = position;
        selectedDraggedItem.current = selectedDataItem;
    };

    const onDragEnter = (e, position, containerName) => {
        console.log(containerName + position);

        draggedAssetItem.current = null;
        draggedOverAsset.current = null;
        selectedDraggedItem.current = null;

        if (containerName === "Destination") {
            draggedOverAsset.current = position;
        }
    };
    const moveUpDown = (index, dataItem, isMoveUp) => {
        if (index === 0 && isMoveUp) return;
        if (!isMoveUp && index === OttPages.length - 1) return;

        const copyAssets = [...OttPages];
        copyAssets.splice(index, 1);
        isMoveUp ? copyAssets.splice(index - 1, 0, dataItem) : copyAssets.splice(index + 1, 0, dataItem);

        setOttPages(copyAssets);
    }
    const onDropOnAssetsFromAssets = (e) => {
        console.log(draggedOverAsset);

        if (draggedOverAsset.current == null) return;

        const copyAssets = [...OttPages];
        //  const dragItemAsset = copyAssets[draggedAssetItem.current];
        copyAssets.splice(draggedAssetItem.current, 1);
        copyAssets.splice(draggedOverAsset.current, 0, selectedDraggedItem.current);
        draggedAssetItem.current = null;
        draggedOverAsset.current = null;
        setOttPages(copyAssets);
    }

    const sideFixMenu = [
        {
            icon: 'play',
            title: `${lang.sidefixmenu_rails_pages_tooltip}`,
            onClick: () => { setOpenPages(old => !old) }
        },
    ]

    const addOttPage = (index, isAddUp) => {
        setAddPages(true);
        setAddOttPagesRef({
            Index: index,
            IsAddUp: isAddUp
        })
    }

    const handlePagesLibrary = (dataList) => {
        var data = [...OttPages];
        var index = addOttPagesRef.current.Index;
        if (addOttPagesRef.current.IsAddUp) {
            let newLocalData1 = [...data.slice(0, index), ...dataList, ...data.slice(index, data.length)];
            setOttPages(utility.getDataWithDisplayValueByLang(newLocalData1, ['Name', 'DisplayName'], selectedLanguageRef.current));
        } else {
            let newLocalData2 = [...data.slice(0, index + 1), ...dataList, ...data.slice(index + 1, data.length)];
            setOttPages(utility.getDataWithDisplayValueByLang(newLocalData2, ['Name', 'DisplayName'], selectedLanguageRef.current));
        }
    }

    const getPageMenu = (index, dataItem) => {
        return [
            {
                label: `${lang.options_actionbutton_menutext}`,
                items: [
                    { label: `${lang.edit_actionbutton_option}`, icon: 'pi pi-fw pi-pencil', command: () => editPages(index, dataItem) },
                    { label: `${lang.delete_actionbutton_option}`, icon: 'pi pi-fw pi-trash', command: () => deleteOttPage(index, dataItem) },
                    { label: `${lang.moveup_actionbutton_option}`, icon: 'pi pi-fw pi-arrow-up ', command: () => moveUpDown(index, dataItem, true) },
                    { label: `${lang.movedown_actionbutton_option}`, icon: 'pi pi-fw pi-arrow-down', command: () => moveUpDown(index, dataItem, false) },
                    { label: `${lang.add_above_option}`, icon: 'pi pi-arrow-circle-up', command: () => addOttPage(index, true) },
                    { label: `${lang.add_below_option}`, icon: 'pi pi-arrow-circle-down', command: () => addOttPage(index, false) }
                ]
            }
        ]
    }

    const onClose = () => {
        if (loc.state && loc.state.prevPath) {
            navigate(loc.state.prevPath)
        } else {
            navigate(-1);
        }
    }

    const customeModelFields = {
        Title: "Name",
        Description: "DisplayName",
        PosterURL: "IconUrl",
        ThirdLine: ""
    };

    return (
        <>
            <FixedSidebarWithIcons menuModel={sideFixMenu} />
            <div className="myFlexContainer">
                {/* Pages */}
                {openPages && <CardList ottMenu={true} customeModelFields={customeModelFields} MenuModel={getPageMenu} showSearch={true} containerName="Destination" cardData={OttPages} onDeleteDataItem={deleteOttPage} close={() => setOpenPages(false)} title={lang.cardlist_pages_menu_title} onAddClick={() => { addOttPage(OttPages.length - 1, false) }} onDragStart={onDragStart} onDragEnter={onDragEnter} onDrop={onDropOnAssetsFromAssets} inTileView={true} showTileView={false} />}
                {/* Add Page Library */}
                {addPages && <PageCollectionSelection title={lang.select_pages_header_collection} entityname={ENTITYNAME.Page} closeForm={() => setAddPages(false)} setDataList={handlePagesLibrary} />}

                {/* edit form */}
                <div className="main-layout">
                    <Form
                        initialValues={dataItem}
                        render={(formRenderProps) => (
                            <FormElement>
                                <EditPageHeader
                                    title={`${lang.ottmenu_title_editpageheader} -> ` + utility.getItemDisplayValueByLang(dataItem?.Name, selectedLanguage)}
                                    onSubmit={handleSubmit}
                                    onCancel={onClose}
                                    languages={languages}
                                    selectedLanguage={selectedLanguage}
                                    setSelectedLanguage={setSelectedLanguage}
                                />
                                <div style={{ boxShadow: "0px 0px 10px 1px lightgrey", backgroundColor: "#EEEEEE", borderRadius: "10px", height: '85vh' }}>
                                    <div className="row mt-2" style={{ margin: "5px" }}>
                                        <div className="col-12">
                                            <div className="row mt-2">
                                                <div className="col-6">
                                                    <MultiLangInput
                                                        name="Name"
                                                        label={lang.name_label}
                                                        dataItem={dataItem}
                                                        selectedLanguage={selectedLanguage}
                                                        setDataItem={setDataItem}
                                                    />
                                                </div>
                                                <div className="col-6">
                                                    <div className="form-group">
                                                        <label htmlFor="">{lang.platform_label} *</label>
                                                        <DropDownList
                                                            style={{
                                                                backgroundColor: "white",
                                                            }}
                                                            data={platform}
                                                            name="Platform"
                                                            textField="Description"
                                                            dataItemKey="_id"
                                                            value={dataItem.Platform}
                                                            onChange={onChange}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-6">
                                                    <div className="form-group">
                                                        <label htmlFor="">{lang.menu_type_label} *</label>
                                                        <DropDownList
                                                            style={{
                                                                backgroundColor: "white",
                                                            }}
                                                            data={menuTypes}
                                                            name="MenuType"
                                                            textField="Description"
                                                            dataItemKey="_id"
                                                            value={dataItem.MenuType}
                                                            onChange={onChange}
                                                            disabled
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-3">
                                            <div className="form-check">
                                                <Field
                                                    name={"Archive"}
                                                    component={Checkbox}
                                                    label={lang.archive}
                                                    style={{ borderColor: "black" }}
                                                    onChange={(e) => onChange(e)}
                                                    checked={dataItem.Archive}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </FormElement>
                        )}
                    />
                </div>
                {showOttPageEditForm && <CustomEditForm
                    {...props} //to get other props from customEditForm
                    cancelEdit={(setShowOttPageEditForm(false))}
                    onSubmit={handleSubmit}
                //  item={editItem}
                />}
            </div >
        </>)
};
